"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactIntl = require("react-intl");
var _default = exports["default"] = (0, _reactIntl.defineMessages)({
  arrowForward: {
    id: 'components.Button.Icon.ArrowForward',
    defaultMessage: 'Prosseguir'
  },
  chevronDown: {
    id: 'components.Button.Icon.ChevronDown',
    defaultMessage: 'Suspender'
  },
  Launch: {
    id: 'components.Button.Icon.Launch',
    defaultMessage: 'Abrir'
  }
});